import { useEffect, useState } from 'react';

/** Breakpoints (px). Desktop-first PBX console. */
export const BP = {
  /** Below this the sidebar auto-collapses to an icon rail. */
  rail: 1024,
  /** Below this two-pane / softphone layouts stack vertically. */
  stack: 1100,
  /** Below this is treated as small/tablet (off-canvas nav territory). */
  narrow: 768,
} as const;

/** Subscribe to a media query; returns its current match. SSR/jsdom-safe. */
export function useMediaQuery(query: string): boolean {
  const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
  const get = () => (supported ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState(get);

  useEffect(() => {
    if (!supported) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query, supported]);

  return matches;
}

/** True when viewport width is at/below the given breakpoint. */
export function useMaxWidth(px: number): boolean {
  return useMediaQuery(`(max-width: ${px}px)`);
}
